<form [formGroup]="form" class="is-fullwidth end-time">

  <div class="is-flex is-fullwidth is-justify-space-between slider-part">
    <div class="is-flex gap-8 text-14 is-family-semiBold">
      <app-text class="text-grey-80">{{ 'legrand-app.__DASHBOARD_MANUAL_SETPOINT_UNTIL' | AsyncLang | async }}</app-text>
      <app-text class="text-netatmo-orange"> {{ manualBoostEndTime() }}</app-text>
    </div>
    <app-icon class="is-cursor-pointer" name="close" (click)="quitManualBoost()"></app-icon>
  </div>

  <el-slider-picker
    formControlName="endTime"
    minLabel=""
    maxLabel=""
    [min]="minEndTime"
    [max]="maxEndTime"
    [step]="5 * 60"
    [legend]="[]"
    [hasText]="false"
    >
  </el-slider-picker>
</form>


